export default __webpack_public_path__ + "mixer.png?924842142078a2a472f4dbd599707915";